import { styled } from "@mui/material";
import Stack from "@mui/material/Stack";
import LogoName from "../../assets/img/reemia-name-white.png";
import Logo from "../../assets/img/white_logo.png";
import { Link } from "../Common/Link";

const LogoContainer = styled("div")({
  position: "relative",
  height: 40,
  "& img": {
    maxHeight: 40,
  },
});

export function AppTitle() {
  return (
    <Link href={"/"} style={{ textDecoration: "none" }}>
      <Stack direction="row" alignItems="center">
        <LogoContainer>
          <div className="flex items-center justify-start">
            <img src={Logo} alt="logo" />
            <img className="ml-4 mb-1 w-24" src={LogoName} alt="logo" />
          </div>
        </LogoContainer>
      </Stack>
    </Link>
  );
}
